import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

import type { ComplimentaryTrialEndEntryPoint } from '../../../contracts/complimentary-trial-end-analytics.types';

/** The T-7 modal is open while this names where it was opened from. */
export const complimentaryTrialEndModalEntryPointAtom =
  atom<ComplimentaryTrialEndEntryPoint | null>(null);

type DismissedCycles = Record<string, true>;

const createSsrSafeLocalStorage = () =>
  createJSONStorage<DismissedCycles>(() => {
    if (typeof window === 'undefined') {
      return {
        getItem: () => null,
        setItem: () => undefined,
        removeItem: () => undefined,
      };
    }
    return localStorage;
  });

/**
 * Banner dismissal keyed by the complimentary cycle's `cycle_end`, so an
 * extended cycle (a new end) brings the banner back for its own last week.
 * Holds the latest dismissed cycle only.
 */
export const complimentaryTrialEndBannerDismissedAtom = atomWithStorage<DismissedCycles>(
  'heidi.complimentaryTrialEndBanner:v1:dismissed',
  {},
  createSsrSafeLocalStorage(),
  { getOnInit: true }
);

export const dismissComplimentaryTrialEndBannerAtom = atom(
  null,
  (get, set, cycleEnd: string) => {
    if (get(complimentaryTrialEndBannerDismissedAtom)[cycleEnd]) return;
    set(complimentaryTrialEndBannerDismissedAtom, { [cycleEnd]: true });
  }
);
